"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserPicker = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Avatar = require("../Avatar/Avatar");
var _reactstrap = require("reactstrap");
var UserPicker = exports.UserPicker = function UserPicker(_ref) {
  var users = _ref.users,
    value = _ref.value,
    _onChange = _ref.onChange,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? "userPicker" : _ref$name,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? "userPicker" : _ref$id;
  var optionNodes = users.map(function (_ref2) {
    var _id = _ref2._id,
      firstName = _ref2.firstName,
      lastName = _ref2.lastName;
    return _react["default"].createElement("option", {
      key: "user-picker-opt-".concat(_id),
      value: _id
    }, "".concat(firstName, " ").concat(lastName));
  });
  var selectedUser = users.find(function (u) {
    return u._id === value;
  });
  return _react["default"].createElement("span", null, selectedUser && _react["default"].createElement(_Avatar.Avatar, {
    user: selectedUser
  }), _react["default"].createElement(_reactstrap.Input, (0, _extends2["default"])({
    type: "select"
  }, {
    name: name,
    id: id,
    value: value
  }, {
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  }), optionNodes));
};